import type { IDocumentNode, PartialNode } from "@shared/common/node/type";
import { noopFunction } from "@shared/common/utils/helper";
import { writable } from "svelte/store";
import Swiper from "swiper";

const defaultSwiper = () => {
  return new Swiper(".nothing", { init: false });
};

const createStore = () => {
  const state = {
    swiperRealIndex: writable(0),
    swiperLength: writable(0),
    swiperInstance: writable(defaultSwiper()),
    swiperOptions: writable({
      ready: false,
      preventSlideOnVideoEnd: false,
    }),
    onSwiperSlide:
      writable<(node: PartialNode<IDocumentNode>) => Promise<void>>(
        noopFunction
      ),
  };
  return {
    state,
    reset: () => {
      state.swiperRealIndex.set(0);
      state.swiperLength.set(0);
      state.swiperInstance.set(defaultSwiper());
      state.swiperOptions.set({
        ready: false,
        preventSlideOnVideoEnd: false,
      });
      state.onSwiperSlide.set(noopFunction);
    },
  };
};

export type SwiperStore = ReturnType<typeof createStore>;

export default createStore;
